import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-kib-component',
  imports: [RouterModule, ToastModule],
  styleUrls: ['./kib.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <router-outlet></router-outlet>
    <p-toast position="bottom-right" key="kib-dialog-import"></p-toast>
  `,
})
export class KibComponent {}
